import { IUseBoolean } from "hooks/use-boolean/use-boolean.types";

export enum KelasLiveCMBStages {
  INITIAL_STAGE = "initial_stage",
  SHOW_INFO_STAGE = "show_info_stage",
  SHOW_FORM_STAGE = "show_form_stage",
  SHOW_ACK_STAGE = "show_ack_stage"
}

export type IKelasLiveCallMeBack = {
  onGoingClassExists: boolean;
};

export type IUseKelasLiveCMB = {
  contactKakakSiagaStage: KelasLiveCMBStages;
  setContactKakakSiagaStage: (stage: KelasLiveCMBStages) => void;
  requestCallBack: (phoneNumber: string) => Promise<boolean>;
  phoneNumber: string;
  setPhoneNumber: (phoneNumber: string) => void;
  showContactKakakSiagaModal: boolean;
  setShowContactKakakSiagaModal: IUseBoolean;
};

export type KelasLiveCMBFormValues = {
  phoneNumber: string;
};
export interface ISupportIssueAPIError {
  text: string;
  status: number;
}
